import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import ConnectedHeaderLogin from "./ConnectedHeaderLogin";

const PageHeader = ({
    additionalText,
    control,
    sectionHeadingId,
    sectionHeading,
    showAdditionalText,
    showHeaderLogin,
    showLockIconInHeading,
}) => (
    <>
        <h2
            className="qg-vendor-header__title header__title .ignore-auto-focus"
            id={sectionHeadingId}
            // tabIndex of -1 ensures that we are able to programatically focus this element
            // but keeps it out of the page tab order so users don't tab to it while using
            // keyboard to navigate the page
            tabIndex={-1}
        >
            {showLockIconInHeading && (
                <Icon
                    glyph="lock-alt-solid"
                    type="FontAwesome"
                    className="-type--xxlarge -margin-right--10"
                />
            )}
            {sectionHeading}
        </h2>
        {showHeaderLogin && <ConnectedHeaderLogin control={control} />}

        {showAdditionalText && (
            <p className="ignore-apply-spacing">{additionalText}</p>
        )}
    </>
);
PageHeader.propTypes = {
    additionalText: PropTypes.string.isRequired,
    control: PropTypes.shape({}).isRequired,
    sectionHeading: PropTypes.string.isRequired,
    showAdditionalText: PropTypes.bool.isRequired,
    showHeaderLogin: PropTypes.bool.isRequired,
    showLockIconInHeading: PropTypes.bool.isRequired,
};

export default PageHeader;
